// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffportal/v1/report_service.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_acl_v1_acl } from "../../acl/v1/acl_pb";
import type { FrameKwh } from "./report_model_pb";
import { file_bffportal_v1_report_model } from "./report_model_pb";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { DealPosition, DeliveryHourType, DeliveryType } from "../../bfftypes/v1/deal_pb";
import { file_bfftypes_v1_deal } from "../../bfftypes/v1/deal_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffportal/v1/report_service.proto.
 */
export const file_bffportal_v1_report_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_acl_v1_acl, file_bffportal_v1_report_model, file_bfftypes_v1_area, file_bfftypes_v1_deal, file_google_type_date, file_google_type_decimal]);

/**
 * @generated from message bffportal.v1.ListOrganizationDealReportsRequest
 */
export type ListOrganizationDealReportsRequest = Message<"bffportal.v1.ListOrganizationDealReportsRequest"> & {
  /**
   * @generated from field: bool exclude_settled = 1;
   */
  excludeSettled: boolean;

  /**
   * @generated from field: optional google.type.Date from_date = 2;
   */
  fromDate?: Date;

  /**
   * @generated from field: optional google.type.Date to_date = 3;
   */
  toDate?: Date;

  /**
   * @generated from field: bool split_by_month = 4;
   */
  splitByMonth: boolean;
};

/**
 * Describes the message bffportal.v1.ListOrganizationDealReportsRequest.
 * Use `create(ListOrganizationDealReportsRequestSchema)` to create a new message.
 */
export const ListOrganizationDealReportsRequestSchema: GenMessage<ListOrganizationDealReportsRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 0);

/**
 * @generated from message bffportal.v1.ListOrganizationDealReportsResponse
 */
export type ListOrganizationDealReportsResponse = Message<"bffportal.v1.ListOrganizationDealReportsResponse"> & {
  /**
   * @generated from field: repeated bffportal.v1.ListOrganizationDealReportsResponse.DealReport deal_reports = 1;
   */
  dealReports: ListOrganizationDealReportsResponse_DealReport[];
};

/**
 * Describes the message bffportal.v1.ListOrganizationDealReportsResponse.
 * Use `create(ListOrganizationDealReportsResponseSchema)` to create a new message.
 */
export const ListOrganizationDealReportsResponseSchema: GenMessage<ListOrganizationDealReportsResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 1);

/**
 * @generated from message bffportal.v1.ListOrganizationDealReportsResponse.DealReport
 */
export type ListOrganizationDealReportsResponse_DealReport = Message<"bffportal.v1.ListOrganizationDealReportsResponse.DealReport"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional google.type.Date dealt_date = 2;
   */
  dealtDate?: Date;

  /**
   * @generated from field: string platform_name = 3;
   */
  platformName: string;

  /**
   * @generated from field: string eclear_deal_code = 4;
   */
  eclearDealCode: string;

  /**
   * @generated from field: bfftypes.v1.DealPosition deal_position = 5;
   */
  dealPosition: DealPosition;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 6;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: google.type.Date delivery_start_date = 7;
   */
  deliveryStartDate?: Date;

  /**
   * @generated from field: google.type.Date delivery_end_date = 8;
   */
  deliveryEndDate?: Date;

  /**
   * @generated from field: bfftypes.v1.DeliveryType delivery_type = 9;
   */
  deliveryType: DeliveryType;

  /**
   * @generated from field: bfftypes.v1.DeliveryType counter_delivery_type = 10;
   */
  counterDeliveryType: DeliveryType;

  /**
   * @generated from field: bfftypes.v1.DeliveryHourType delivery_hour_type = 11;
   */
  deliveryHourType: DeliveryHourType;

  /**
   * @generated from field: google.type.Decimal volume_in_kw = 12;
   */
  volumeInKw?: Decimal;

  /**
   * @generated from field: double total_delivery_hour = 13;
   */
  totalDeliveryHour: number;

  /**
   * @generated from field: google.type.Decimal total_kwh = 14;
   */
  totalKwh?: Decimal;

  /**
   * @generated from field: string unit_price_per_kwh = 15;
   */
  unitPricePerKwh: string;

  /**
   * @generated from field: optional string current_market_price = 16;
   */
  currentMarketPrice?: string;

  /**
   * @generated from field: double mtm = 17;
   */
  mtm: number;

  /**
   * @generated from field: google.type.Decimal clearing_fee_rate = 18;
   */
  clearingFeeRate?: Decimal;

  /**
   * @generated from field: google.type.Decimal fee = 19;
   */
  fee?: Decimal;

  /**
   * @generated from field: bool is_settled = 20;
   */
  isSettled: boolean;

  /**
   * @generated from field: optional string formula = 21;
   */
  formula?: string;

  /**
   * 差額精算対象エリア。JEPX渡しで受電エリア(area_code)とは別エリアの
   * JEPXスポット価格で差額精算する場合のみ設定される。通常は未設定。
   *
   * @generated from field: optional bfftypes.v1.AreaCode settlement_difference_target_area_code = 22;
   */
  settlementDifferenceTargetAreaCode?: AreaCode;
};

/**
 * Describes the message bffportal.v1.ListOrganizationDealReportsResponse.DealReport.
 * Use `create(ListOrganizationDealReportsResponse_DealReportSchema)` to create a new message.
 */
export const ListOrganizationDealReportsResponse_DealReportSchema: GenMessage<ListOrganizationDealReportsResponse_DealReport> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 1, 0);

/**
 * @generated from message bffportal.v1.ListOrganizationDealPerFrameRequest
 */
export type ListOrganizationDealPerFrameRequest = Message<"bffportal.v1.ListOrganizationDealPerFrameRequest"> & {
  /**
   * @generated from field: bool exclude_settled = 1;
   */
  excludeSettled: boolean;

  /**
   * @generated from field: optional google.type.Date from_date = 2;
   */
  fromDate?: Date;

  /**
   * @generated from field: optional google.type.Date to_date = 3;
   */
  toDate?: Date;
};

/**
 * Describes the message bffportal.v1.ListOrganizationDealPerFrameRequest.
 * Use `create(ListOrganizationDealPerFrameRequestSchema)` to create a new message.
 */
export const ListOrganizationDealPerFrameRequestSchema: GenMessage<ListOrganizationDealPerFrameRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 2);

/**
 * @generated from message bffportal.v1.ListOrganizationDealPerFrameResponse
 */
export type ListOrganizationDealPerFrameResponse = Message<"bffportal.v1.ListOrganizationDealPerFrameResponse"> & {
  /**
   * @generated from field: repeated bffportal.v1.ListOrganizationDealPerFrameResponse.DealPerFrame deals_per_frame = 1;
   */
  dealsPerFrame: ListOrganizationDealPerFrameResponse_DealPerFrame[];
};

/**
 * Describes the message bffportal.v1.ListOrganizationDealPerFrameResponse.
 * Use `create(ListOrganizationDealPerFrameResponseSchema)` to create a new message.
 */
export const ListOrganizationDealPerFrameResponseSchema: GenMessage<ListOrganizationDealPerFrameResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 3);

/**
 * @generated from message bffportal.v1.ListOrganizationDealPerFrameResponse.DealPerFrame
 */
export type ListOrganizationDealPerFrameResponse_DealPerFrame = Message<"bffportal.v1.ListOrganizationDealPerFrameResponse.DealPerFrame"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.DealPosition deal_position = 3;
   */
  dealPosition: DealPosition;

  /**
   * @generated from field: repeated bffportal.v1.FrameKwh frames = 4;
   */
  frames: FrameKwh[];
};

/**
 * Describes the message bffportal.v1.ListOrganizationDealPerFrameResponse.DealPerFrame.
 * Use `create(ListOrganizationDealPerFrameResponse_DealPerFrameSchema)` to create a new message.
 */
export const ListOrganizationDealPerFrameResponse_DealPerFrameSchema: GenMessage<ListOrganizationDealPerFrameResponse_DealPerFrame> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 3, 0);

/**
 * @generated from message bffportal.v1.ListOrganizationMarginReportsRequest
 */
export type ListOrganizationMarginReportsRequest = Message<"bffportal.v1.ListOrganizationMarginReportsRequest"> & {
  /**
   * @generated from field: optional google.type.Date from_date = 1;
   */
  fromDate?: Date;

  /**
   * @generated from field: optional google.type.Date to_date = 2;
   */
  toDate?: Date;
};

/**
 * Describes the message bffportal.v1.ListOrganizationMarginReportsRequest.
 * Use `create(ListOrganizationMarginReportsRequestSchema)` to create a new message.
 */
export const ListOrganizationMarginReportsRequestSchema: GenMessage<ListOrganizationMarginReportsRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 4);

/**
 * @generated from message bffportal.v1.ListOrganizationMarginReportsResponse
 */
export type ListOrganizationMarginReportsResponse = Message<"bffportal.v1.ListOrganizationMarginReportsResponse"> & {
  /**
   * @generated from field: repeated bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportEntry entries = 1;
   */
  entries: ListOrganizationMarginReportsResponse_MarginReportEntry[];
};

/**
 * Describes the message bffportal.v1.ListOrganizationMarginReportsResponse.
 * Use `create(ListOrganizationMarginReportsResponseSchema)` to create a new message.
 */
export const ListOrganizationMarginReportsResponseSchema: GenMessage<ListOrganizationMarginReportsResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 5);

/**
 * @generated from message bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportDetail
 */
export type ListOrganizationMarginReportsResponse_MarginReportDetail = Message<"bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportDetail"> & {
  /**
   * @generated from field: int64 total_collateral_amount = 2;
   */
  totalCollateralAmount: bigint;

  /**
   * @generated from field: google.type.Decimal required_margin = 3;
   */
  requiredMargin?: Decimal;

  /**
   * @generated from field: google.type.Decimal realized_amount = 4;
   */
  realizedAmount?: Decimal;

  /**
   * @generated from field: google.type.Decimal unrealized_amount = 5;
   */
  unrealizedAmount?: Decimal;

  /**
   * @generated from field: bool is_margin_call_day = 6;
   */
  isMarginCallDay: boolean;

  /**
   * @generated from field: google.type.Decimal surplus = 7;
   */
  surplus?: Decimal;

  /**
   * @generated from field: google.type.Decimal initial_margin = 8;
   */
  initialMargin?: Decimal;

  /**
   * @generated from field: google.type.Decimal materialized_unsettled_amount = 9;
   */
  materializedUnsettledAmount?: Decimal;

  /**
   * @generated from field: int64 performance_guarantee = 10;
   */
  performanceGuarantee: bigint;

  /**
   * @generated from field: int64 total_credit_amount = 11;
   */
  totalCreditAmount: bigint;

  /**
   * @generated from field: int64 guarantee_issuance_limit = 12;
   */
  guaranteeIssuanceLimit: bigint;
};

/**
 * Describes the message bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportDetail.
 * Use `create(ListOrganizationMarginReportsResponse_MarginReportDetailSchema)` to create a new message.
 */
export const ListOrganizationMarginReportsResponse_MarginReportDetailSchema: GenMessage<ListOrganizationMarginReportsResponse_MarginReportDetail> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 5, 0);

/**
 * @generated from message bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportEntry
 */
export type ListOrganizationMarginReportsResponse_MarginReportEntry = Message<"bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportEntry"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: optional bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportDetail detail = 2;
   */
  detail?: ListOrganizationMarginReportsResponse_MarginReportDetail;
};

/**
 * Describes the message bffportal.v1.ListOrganizationMarginReportsResponse.MarginReportEntry.
 * Use `create(ListOrganizationMarginReportsResponse_MarginReportEntrySchema)` to create a new message.
 */
export const ListOrganizationMarginReportsResponse_MarginReportEntrySchema: GenMessage<ListOrganizationMarginReportsResponse_MarginReportEntry> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_service, 5, 1);

/**
 * @generated from service bffportal.v1.ReportService
 */
export const ReportService: GenService<{
  /**
   * @generated from rpc bffportal.v1.ReportService.ListOrganizationDealReports
   */
  listOrganizationDealReports: {
    methodKind: "unary";
    input: typeof ListOrganizationDealReportsRequestSchema;
    output: typeof ListOrganizationDealReportsResponseSchema;
  },
  /**
   * @generated from rpc bffportal.v1.ReportService.ListOrganizationDealPerFrame
   */
  listOrganizationDealPerFrame: {
    methodKind: "unary";
    input: typeof ListOrganizationDealPerFrameRequestSchema;
    output: typeof ListOrganizationDealPerFrameResponseSchema;
  },
  /**
   * @generated from rpc bffportal.v1.ReportService.ListOrganizationMarginReports
   */
  listOrganizationMarginReports: {
    methodKind: "unary";
    input: typeof ListOrganizationMarginReportsRequestSchema;
    output: typeof ListOrganizationMarginReportsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffportal_v1_report_service, 0);

